var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",on:{"click":_vm.toggle}},[_vm._v("\n  "+_vm._s(_vm.isOn ? _vm.valueOnText : _vm.valueOffText)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }